import { Injectable,signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InvoicesignalService {

   private invoiceNoSubject = new BehaviorSubject<string | null>(null);
  invoiceNo$ = this.invoiceNoSubject.asObservable();  // Expose as observable

  setInvoiceNo(value: string) {
    this.invoiceNoSubject.next(value);
  }
}
